import { HTTP_CLIENT } from '../../axios-wrapper'
import { unpackRules } from '@casl/ability/extra'
import router from '@/router/'

const state = {
  authenticated: false
}

const getters = {
  isAuthenticated: state => state.authenticated
}

const actions = {
  'LOGIN': ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      HTTP_CLIENT
        .post('auth/login', {
          email: user.email,
          password: user.password
        })
        .then(response => {
          commit('AUTH_SUCCESS', { root: true })
          commit('AUTH_BIND_ABILITIES', response.data.abilities)

          const { _id, name, firstname } = response.data.user
          dispatch('user/GET_USER_INFOS', {
            id: _id,
            name,
            firstname
          }, { root: true })
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  'AUTOLOGIN': async ({ commit, dispatch }) => {
    try {
      let { data } = await HTTP_CLIENT.get('/auth/autologin')
      commit('AUTH_SUCCESS', { root: true })
      commit('AUTH_BIND_ABILITIES', data.abilities)

      const { _id, name, firstname } = data.user
      await dispatch('user/GET_USER_INFOS', {
        id: _id,
        name,
        firstname
      }, { root: true })
    } catch (err) {
      throw err
    }
  },
  'LOGOUT': async ({ commit }) => {
    try {
      await HTTP_CLIENT.get('/auth/logout')
      commit('AUTH_BIND_ABILITIES', [])
      commit('AUTH_LOGOUT')
    } catch (err) {
      throw err
    } finally {
      router.push('/login')
    }
  }
}

const mutations = {
  'AUTH_SUCCESS': state => { state.authenticated = true },
  'AUTH_BIND_ABILITIES': (state, abilities) => {
    router.app.$ability.update(unpackRules(abilities))
  },
  'AUTH_LOGOUT': state => { state.authenticated = false }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
